import ConnectedFormsApi from '../api/ConnectedForms';
import * as ActionTypes from './ActionTypes';
export function getConnectedForms(searchString) {
  return dispatch => {
    return ConnectedFormsApi.getConnectedForms(searchString).then(payload => dispatch({
      type: ActionTypes.FETCH_CONNECTED_FORMS_SUCCESS,
      payload
    }));
  };
}